/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Size_Not_In_RunInputs */

const en_issue_size_not_in_run = /** @type {(inputs: Issue_Size_Not_In_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not a size of the size run`)
};

/**
* | output |
* | --- |
* | "not a size of the size run" |
*
* @param {Issue_Size_Not_In_RunInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_size_not_in_run = /** @type {((inputs?: Issue_Size_Not_In_RunInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Size_Not_In_RunInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_size_not_in_run(inputs)
});